const consts = {
    CDN_PREFIX: "cdn.picrew.me"
}

export default consts